import { createSelector } from 'reselect';
import { keys } from '../../../constants/keys.esm.js';

var createCategoryChangeCallbackSelector = function createCategoryChangeCallbackSelector() {
  return createSelector(function (props) {
    return props.onCategoryChange;
  }, function (onCategoryChange) {
    return function (_event, value, reason) {
      if (reason === 'selectOption') {
        if (onCategoryChange) {
          if (!(value !== null && value !== void 0 && value.id)) {
            onCategoryChange(keys.allFields);
          } else {
            onCategoryChange(value.id);
          }
        }
      }
    };
  });
};

export { createCategoryChangeCallbackSelector };
//# sourceMappingURL=category-change-callback-selector.esm.js.map
